import React from 'react'
import CompanySpecificJobs from '../Explore/CompanySpecificJobs'

function CompanySpecificJob() {
  return (
    <>
        <CompanySpecificJobs />
    </>
  )
}

export default CompanySpecificJob
